import { useEffect } from 'react';
import fetch from '@api/axios';
import { logout } from '@/store/actions/authActions';


export const useAxiosUnauthorizedInterceptor = (dispatch) => {
    useEffect(() => {
        const interceptor = fetch.interceptors?.response?.use(
            (res) => res,
            (err) => {
                if (err?.response?.status === 401) {
                    dispatch(logout());
                }
                return Promise.reject(err);
            }
        );

        return () => {
            fetch.interceptors?.response?.eject(interceptor);
        };
    }, [dispatch]);
};
